// Handle BIS (Back in Stock) button visibility based on variant availability
(function() {
  const variantSelectionEl = document.querySelector('variant-selection');
  if (!variantSelectionEl) return;

  // Function to fetch product data and update BIS button
  async function updateBISButton() {
    const productUrl = variantSelectionEl.getAttribute('product-url');
    if (!productUrl) return;

    try {
      const response = await fetch(productUrl);
      const productData = await response.json();
      const variantId = variantSelectionEl.getAttribute('variant');
      
      // Find BIS button (try both class and id selectors)
      const bisButton = document.querySelector('.BIS_trigger, #BIS_trigger');
      if (!bisButton) return;

      // Find the selected variant
      const selectedVariant = productData.variants.find(v => v.id == variantId);
      
      if (selectedVariant) {
        // Show button if variant is not available, hide if it is available
        if (selectedVariant.available) {
          bisButton.style.display = 'none';
        } else {
          bisButton.style.display = '';
        }
      }
    } catch (error) {
      console.error('Error updating BIS button:', error);
    }
  }

  // Listen for variant changes
  variantSelectionEl.addEventListener('change', updateBISButton);
  
  // Initial update on page load
  updateBISButton();
})();

